export default class AService {
  /**
   * @param {AxiosInstance} http
   * @param {String} baseUrl
   */
  constructor (http, baseUrl) {
    this.http = http
    this.baseUrl = baseUrl
  }
}
